import React from "react";
import { useNavigate } from "react-router-dom";

// Imported images and their names for products
import DesignerMetal from "../assets/images/DesignerMetal.png";
import FrameLess from "../assets/images/FrameLess.png";
import FullFrame from "../assets/images/FullFrame.png";
import HalfFrame from "../assets/images/HalfFrame.png";
import SafetyGlassess from "../assets/images/SafetyGlasses.png";
import Sunglassess from "../assets/images/SunGlasses.png";

// Route mapping for each product type
const routeMapping = {
  "Designer Metal": "/dma",
  "Frame Less": "/fla",
  "Full Frame": "/ffa",
  "Half Frame": "/hfa",
  "Sunglasses": "/sga",
  "Safety Glasses": "/sa",
};

export default function TypeProducts() {
  const navigate = useNavigate();

  const products = [
    { name: "Designer Metal", image: DesignerMetal },
    { name: "Frame Less", image: FrameLess },
    { name: "Full Frame", image: FullFrame },
    { name: "Half Frame", image: HalfFrame },
    { name: "Safety Glasses", image: SafetyGlassess },
    { name: "Sunglasses", image: Sunglassess },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Responsive grid: 1 column on extra small, 2 on small, and 3 on medium and up */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {products.map((product, index) => (
          <div
            key={index}
            onClick={() => navigate(routeMapping[product.name])}
            className="cursor-pointer transition-transform duration-300 hover:scale-105 hover:shadow-xl"
          >
            {/* Outer container with gradient border */}
            <div className="p-1 bg-gradient-to-r from-blue-300 to-pink-300 rounded-xl h-40 sm:h-44 md:h-48">
              {/* Inner card that fills the container */}
              <div className="flex items-center p-2 bg-white rounded-xl h-full">
                {/* Product name on the left */}
                <div className="w-1/3">
                  <p className="text-sm sm:text-base md:text-lg font-bold text-black">
                    {product.name}
                  </p>
                </div>

                {/* Product image on the right */}
                <div className="w-2/3 h-full flex items-center justify-center">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-auto max-h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
